<div class="header-main">
    <core-title-section [title]="title" [breadcrumbs]="breadcrumbs"></core-title-section>
    <div [hidden]="version == null || exclude.length == 0" class="labels-header-container">
        <core-labels-text [labels]="exclude"></core-labels-text>
        <span class="plus" [hidden]="diffLabels.length == 0">+ </span>
        <core-labels-text [labels]="diffLabels"></core-labels-text>
    </div>
    <div class="loader" [hidden]="version != null">
        <div class="dimmed">
            <div class="dimmed_content">
                <div class="dimmed_flex">
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                </div>
            </div>
        </div>
    </div>
    <version-helper-three-dot-status-update-menu 
        *ngIf="version != null && menu.length > 0"
        [version]="version"
        [menu]="menu" 
        (action)="onMenuSelect($event)" 
        (actionStatus)="onStatusMenuSelect($event)"></version-helper-three-dot-status-update-menu>
</div>